<template>
  <div :class="$style.box">
    <TopHeader headerTitle="我的代金券" :isShowMenuIcon="false" />
    <div :class="$style.tabs">
      <div v-for="(item, index) of tabModel" :key="index" :class="$style['tab-item']">
        <input
          type="radio"
          name="tab"
          :id="item.name"
          :checked="index === 0"
          @click="handleTabChange"
        />
        <label :for="item.name">{{ item.title }}</label>
      </div>
    </div>
    <section :class="$style.list" style="margin-top: 7px">
      <div v-if="tabActive === 'hasVouchers' || tabActive === 'failureVouchers'">
        <div v-for="item of vouchersList" :key="item.id">
          <CircleBaseBox style="padding-bottom: 0" :circleMinHeight="'89px'">
            <div :class="$style.item">
              <div :class="$style.info">
                <div>
                  <p>{{ item.name }}</p>
                  <p>{{ item.dataStr }}</p>
                </div>
                <div v-if="tabActive === 'hasVouchers'">{{ item.remainTimeStr }}</div>
                <div style="background-color: #e2e2e2; color: #717171" v-else>已过期失效</div>
              </div>
              <p>{{ item.remark }}</p>
            </div>
          </CircleBaseBox>
        </div>
      </div>
      <div v-if="tabActive === 'useRecords'">
        <div v-if="useRecordsList.length">
          <div v-for="(item, index) of useRecordsList" :key="index">
            <CircleBaseBox style="padding-bottom: 0" :circleMinHeight="'73px'">
              <div :class="$style.item">
                <div :class="[$style.info, $style.record]">
                  <div>
                    <p>{{ item.name }}</p>
                    <p style="margin: 8px 0px 11.7px 0px">
                      {{ item.used_day }}
                    </p>
                  </div>
                  <div style="top: 14px; right: 0px; background-color: #ffffff; font-size: 12.5px">
                    {{ '充值' + item.product_name }}
                  </div>
                </div>
                <div :class="$style['record-game-info']">
                  <img :src="`${$cdnUrl}/ticket/images_6.png`" /><span>{{
                    item.version_name
                  }}</span>
                  <img :src="`${$cdnUrl}/ticket/images_5.png`" /><span>{{ item.role_name }}</span>
                </div>
              </div>
            </CircleBaseBox>
          </div>
        </div>
        <div v-else :class="$style['no-use-record']">
          <img :src="`${$cdnUrl}/ticket/images_4.png`" />
          <p>你还没有使用过代金券哦</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { CDN_URL } from "@/config/index.js";
import TopHeader from '_c/TopHeader';
import CircleBaseBox from '_c/CircleBaseBox';
import { Tab, Tabs } from 'vant';
import {
  voucherHaveList,
  voucherRecordList,
  voucherInvalidList
} from '@/api/activity';
import { remainTime } from '@/utils/index';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      title: '我的代金券',
      tabModel: [
        {
          title: '已有代金券',
          name: 'hasVouchers',
        },
        {
          title: '使用记录',
          name: 'useRecords',
        },
        {
          title: '已失效代金券',
          name: 'failureVouchers',
        },
      ],
      tabActive: 'hasVouchers',
      vouchersList: [],
      useRecordsList: [],
    };
  },
  components: {
    TopHeader,
    CircleBaseBox,
    Tabs,
    Tab
  },
  created() {
    this.getVoucherHaveList()
  },
  methods: {
    handleTabChange(e) {
      this.tabActive = e.target.id
      switch (this.tabActive) {
        case 'hasVouchers':
          this.getVoucherHaveList()
          break;
        case 'useRecords':
          this.getVoucherRecordList()
          break;
        case 'failureVouchers':
          this.getVoucherInvalidList()
          break;
        default:
          break;
      }
    },
    // 获取已有代金券列表
    async getVoucherHaveList() {
      this.vouchersList = []
      const r = await voucherHaveList()
      const list = r.data.map(item => {
        return Object.assign(item, {
          dataStr: dayjs(item.effective_time).format('YYYY年M月D日') + '-' + dayjs(item.invalid_time).format('YYYY年M月D日'),
          remainTimeStr: remainTime(dayjs(item.invalid_time).valueOf()),
          remark: item.type === 1 ? `单笔订单满${item.condition_money}可用` : `单笔订单打${item.name}`
        })
      })
      this.vouchersList = [...list]
    },
    // 获取已失效代金券
    async getVoucherInvalidList() {
      this.vouchersList = []
      const r = await voucherInvalidList()
      const list = r.data.map(item => {
        return Object.assign(item, {
          dataStr: dayjs(item.effective_time).format('YYYY年M月D日') + '-' + dayjs(item.invalid_time).format('YYYY年M月D日'),
          remark: item.type === 1 ? `单笔订单满${item.condition_money}可用` : `单笔订单打${item.name}`
        })
      })
      this.vouchersList = [...list]
    },
    // 获取使用记录
    async getVoucherRecordList() {
      const r = await voucherRecordList()
      const list = r.data.map(item => {
        return Object.assign(item, {
          used_day: dayjs(item.use_time).format('YYYY年M月D日') + '使用'
        })
      })
      this.useRecordsList = [...r.data];
    },
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 100vw;
  height: calc(100vh - 52px);
  background-color: #efefef;
}
.tabs {
  margin-top: 1px;
  padding-left: 17px;
  width: 100%;
  height: 39px;
  display: flex;
  align-items: center;
  background-color: #fff;
  font-size: 11px;
  color: #9f9f9f;
  .tab-item {
    & + div {
      margin-left: 22px;
    }
    input {
      display: none;
      &:checked + label {
        color: #000000;
        &::after {
          content: '';
          position: relative;
          top: 5px;
          margin: auto;
          width: 45px;
          height: 2px;
          display: block;
          background-color: #fd925a;
        }
      }
    }
  }
}
.list {
  height: calc(100% - 90px);
  overflow-y: auto;
}
.item {
  .info {
    @include border-bottom-1px;
    display: flex;
    margin-top: 7px;
    > div:first-of-type {
      > p:first-child {
        font-size: 16px;
        font-family: '黑体';
      }
      > p:last-child {
        margin: 12px 0 14px 0px;
        font-size: 9.7px;
        color: #9f9f9f;
      }
    }
    > div:nth-of-type(2) {
      position: absolute;
      top: 5px;
      right: 6px;
      padding: 0px 11.7px;
      width: fit-content;
      height: 17.4px;
      background-color: #ffede9;
      border-radius: 8.6px;
      font-size: 9px;
      line-height: 17.4px;
      color: #ff452e;
    }
  }
  > p {
    height: 28px;
    line-height: 28px;
    font-size: 9.7px;
    color: #9f9f9f;
  }
  .record {
    @include border-bottom-1px(0, 0);
    > div:first-of-type {
      > p:first-child {
        font-size: 13px;
        font-family: '黑体';
      }
    }
  }
  .record-game-info {
    padding-bottom: 6.5px;
    font-size: 10px;
    color: #9f9f9f;
    > img {
      margin-right: 3px;
      width: 9px;
    }
    > span {
      margin: 0 13.8px 0 1px;
    }
  }
}
.no-use-record {
  margin-top: 109px;
  text-align: center;
  > img {
    width: 58.5px;
  }
  > p {
    margin-top: 8.7px;
    font-size: 11px;
    color: #9f9f9f;
  }
}
</style>
